// autogenerated file at: 10/13/2022, 8:22:31 AM

export const lastUpdatedTimestamp = new Date(1665674551997);

export const cleanedAddresses = 
[
	"0x4abf2123bcddce3f853066645ae2e0e1c1a7d0e9",
	"0xa9eef692f818501e7b0a7538f35af0455b9e6f96"
];